import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { RootState } from './store'

interface HeaderTitleState {
  title: string
}

const initialState: HeaderTitleState = {
  title: '',
}

const headerTitleSlice = createSlice({
  name: 'headerTitle',
  initialState,
  reducers: {
    setTitle: (state, action: PayloadAction<string>) => {
      state.title = action.payload
    },
  },
})

export const getTitle = (state: RootState) => state.headerTitle.title
export const { setTitle } = headerTitleSlice.actions

export default headerTitleSlice.reducer
